"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = exports.StyledFlexWrapper = exports.StyledSERIF_4_5 = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var Container_1 = require("../../Container");
var Typo_1 = require("../../Typo");
var mixins_1 = require("../../../themes/mixins");
var fadeIn = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"], ["\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"])));
exports.StyledSERIF_4_5 = (0, styled_components_1.default)(Typo_1.SERIF_4_5)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n    ", "\n\n"], ["\n\n    ", "\n\n"])), function (_a) {
    var preset = _a.preset;
    return preset === 'successFullyPublish' && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        opacity: 0;\n        animation: ", " 1s 2s forwards; // delay for 2 sec before showing text\n    "], ["\n        opacity: 0;\n        animation: ", " 1s 2s forwards; // delay for 2 sec before showing text\n    "])), fadeIn);
});
exports.StyledFlexWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: ", ";\n  gap: 2rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: ", ";\n  gap: 2rem;\n"])), function (_a) {
    var align = _a.align;
    return (align === "center" ? "center" : "flex-start");
});
exports.StyledContainer = (0, styled_components_1.default)(Container_1.Container)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n\n  padding: ", ";\n  display: ", ";\n  justify-content: \"center\";\n  text-align: ", ";\n\n  ", " {\n    padding: ", ";\n  }\n"], ["\n  ", "\n\n  padding: ", ";\n  display: ", ";\n  justify-content: \"center\";\n  text-align: ", ";\n\n  ", " {\n    padding: ", ";\n  }\n"])), function (_a) {
    var preset = _a.preset;
    return preset === 'successFullyPublish' && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          width: 100svw;\n          height: 100svh;\n          background: radial-gradient(circle, rgba(255,255,255,1) 32%, rgba(56,56,56,1) 97%);\n          overflow: hidden;\n          position: relative;\n    "], ["\n          width: 100svw;\n          height: 100svh;\n          background: radial-gradient(circle, rgba(255,255,255,1) 32%, rgba(56,56,56,1) 97%);\n          overflow: hidden;\n          position: relative;\n    "])));
}, function (props) { return (props.align === "center" ? "2rem 0rem" : "4rem 0"); }, function (props) { return props.align === "center" && "flex"; }, function (props) { return props.align === "center" && "center"; }, (0, mixins_1.mediaQuery)("sm"), function (props) { return (props.align === "center" ? "4rem 0" : "6rem 0"); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
